export default __webpack_public_path__ + "static/media/org-switch.55d8e4ac.svg";